import { Injectable } from '@angular/core';
import { BaseApiService } from 'src/app/shared/services/api';
import { UserResponse } from 'src/app/core/models/user.model';
import { SavedSearchInterface, MappingsAvailabilityInterface, IntentAutomationReportCompanyIdsInterface, RunIntentAutomationInterface } from '../../../modals/intent-settings/models';
import { Observable } from 'rxjs';
import { ExportErrorsResponseApiDto, CrmFieldsResponseDto, MappingFieldsRequestParamDto } from '../../dto';
import { AutomationErrorsResponseApiDto } from '../../dto';
import { SavedAutomationInterface } from '../../models';

@Injectable({
    providedIn: 'root'
})
export class IntentAutomationApiService {

    constructor(private baseApiService: BaseApiService) { }

    getSavedSearch(): Observable<SavedSearchInterface[]> {
        return this.baseApiService.get<SavedSearchInterface[]>('service/contactcloud/search/savedSearch/allPublic');
    }

    getAccountActiveUsers(accuntId: number): Observable<UserResponse> {
        return this.baseApiService.get<UserResponse>(`account/activeUsers/${accuntId}`, { excludeImpersonate: true });
    }

    saveIntentAutomation(newIntentObj: SavedAutomationInterface) {
        return this.baseApiService.post(`service/contactcloud/intent/automations/save`, newIntentObj);
    }

    getMappingsAvailability(intent_type: string = 'SALES_INTEL'): Observable<MappingsAvailabilityInterface> {
        return this.baseApiService.get<MappingsAvailabilityInterface>(`service/contactcloud/intent/mappings-availability`, { params: { intent_type } });
    }

    getIntentAutomations(params: any = {}): Observable<SavedAutomationInterface[]> {
        return this.baseApiService.get(`service/contactcloud/intent/automations`, { params });
    }

    deleteAutomation(automationId: number): Observable<void> {
        return this.baseApiService.delete(`service/contactcloud/intent/automations/${automationId}`);
    }

    updateAutomation(automationId: number, updatedAutomation: SavedAutomationInterface): Observable<void> {
        return this.baseApiService.put(`service/contactcloud/intent/automations/${automationId}`, updatedAutomation);
    }

    getCompanyIdsForReport(intentReportId: string): Observable<IntentAutomationReportCompanyIdsInterface> {
        return this.baseApiService.get<IntentAutomationReportCompanyIdsInterface>(`service/contactcloud/intent/report/${intentReportId}/companyIds`);
    }

    getExportErrors(): Observable<ExportErrorsResponseApiDto | AutomationErrorsResponseApiDto[]> {
        return this.baseApiService.get<ExportErrorsResponseApiDto | AutomationErrorsResponseApiDto[]>(`service/contactcloud/intent/export/errors`);
    }

    runIntentAutomation(intentObj: RunIntentAutomationInterface): Observable<null> {
        return this.baseApiService.post(`service/contactcloud/intent/automation/run`, intentObj, { showError: true });
    }

    getCRMMappingFields(crm: string, params: MappingFieldsRequestParamDto = {}): Observable<CrmFieldsResponseDto> {
        const requestParams = params.isAutomation ? { is_automation: true } : {};
        return this.baseApiService.get<CrmFieldsResponseDto>(`service/contactcloud/${crm.toLowerCase()}/fields`, { params: requestParams });
    }

}
